<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisConfirmModal from 'dashboard/components-next/LaisConfirmModal.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  listName: { type: String, default: '' },
  isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'confirm']);

const description = computed(() => {
  if (!props.listName) {
    return 'Esta ação remove a lista selecionada.';
  }

  return `Tem certeza que deseja excluir a lista "${props.listName}"? Os imóveis salvos nela serão removidos desta lista.`;
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisConfirmModal
    :show="show"
    title="Excluir lista"
    :description="description"
    confirm-text="Excluir"
    cancel-text="Manter lista"
    :is-loading="isLoading"
    @close="emit('close')"
    @confirm="emit('confirm')"
  />
</template>
